/**
 * @author Rafael Nascimento
 * @version $Id$
 */
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { VivoSyncComponent } from '../content.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { ConfigureSyncLeavePage } from '../configureLeavePage/content.component';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

@Injectable()
export class CanLeaveSyncGuard implements CanDeactivate<VivoSyncComponent> {
     constructor(private modalService: NgbModal) { }
     canDeactivate(target: VivoSyncComponent): Observable<boolean>|Promise<boolean>|boolean {
          if (target.syncListComponent.selectedLineAcount.length !== 0) {

              return Observable.create((observer: Observer<boolean>) => {
                  const dialogRef = this.modalService.open(ConfigureSyncLeavePage);
                  dialogRef.result.then(result => {
                      switch (result) {
                          case 'leave':
                              observer.next(true);
                              break;
                          case 'cancel':
                              observer.next(false);
                              break;
                          case 'save':
                              target.syncListComponent.configPermissaoLinhas();
                              observer.next(false);
                              break;
                          default:
                              observer.next(false);
                              break;
                      }
                      observer.complete();
                  }, (error) => {
                      observer.next(false);
                      observer.complete();
                  }
                  )
              });
          } else {
              return true;
          }
      }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/vivosync/canleavesyncguard/content.component.ts